import type { WidgetKey, WidgetRegistryEntry, LayoutSnapshot, SlotPlacement, LayoutScope } from "./types";
import { GRID_COLS, GRID_ROW_HEIGHT } from "./types";

export { GRID_COLS, GRID_ROW_HEIGHT };

const PFM_FILTERS_ROW_HEIGHT = 60;

export const WIDGET_REGISTRY: Record<WidgetKey, WidgetRegistryEntry> = {
  "net-pnl":        { key: "net-pnl",        scope: "both", minColSpan: 1, maxColSpan: 3, defaultColSpan: 1, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 2, rowHeight: 150 },
  "profit-factor":  { key: "profit-factor",  scope: "both", minColSpan: 1, maxColSpan: 3, defaultColSpan: 1, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 2, rowHeight: 150 },
  "win-rate":       { key: "win-rate",       scope: "both", minColSpan: 2, maxColSpan: 3, defaultColSpan: 2, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 2, rowHeight: 150 },
  "avg-win-loss":   { key: "avg-win-loss",   scope: "both", minColSpan: 1, maxColSpan: 3, defaultColSpan: 1, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 2, rowHeight: 150 },
  "market-hours":   { key: "market-hours",   scope: "dashboard", minColSpan: 1, maxColSpan: 3, defaultColSpan: 1, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT },
  "routines":       { key: "routines",       scope: "dashboard", minColSpan: 1, maxColSpan: 3, defaultColSpan: 1, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 3, rowHeight: 100 },
  "goals":          { key: "goals",          scope: "dashboard", minColSpan: 1, maxColSpan: 3, defaultColSpan: 1, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 3, rowHeight: 100 },
  "session":        { key: "session",        scope: "dashboard", minColSpan: 1, maxColSpan: 3, defaultColSpan: 1, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 3, rowHeight: 100 },
  "calendar":       { key: "calendar",       scope: "dashboard", minColSpan: 3, maxColSpan: 6, defaultColSpan: 4, minRowSpan: 4, defaultRowSpan: 4, maxRowSpan: 6, rowHeight: GRID_ROW_HEIGHT },
  "equity-chart":   { key: "equity-chart",   scope: "dashboard", minColSpan: 2, maxColSpan: 6, defaultColSpan: 4, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 4, rowHeight: GRID_ROW_HEIGHT },
  "accounts-table": { key: "accounts-table", scope: "dashboard", minColSpan: 3, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 4, rowHeight: GRID_ROW_HEIGHT },
  "analytics-kpis":     { key: "analytics-kpis",     scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT },
  "equity-curve":       { key: "equity-curve",        scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 4, rowHeight: GRID_ROW_HEIGHT },
  "pnl-distribution":   { key: "pnl-distribution",    scope: "both", minColSpan: 1, maxColSpan: 6, defaultColSpan: 3, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT },
  "monthly-pnl":        { key: "monthly-pnl",         scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT },
  "symbol-performance": { key: "symbol-performance",  scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT, requiredPlan: "Pro" },
  "rolling-win-rate":   { key: "rolling-win-rate",    scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT, requiredPlan: "Pro" },
  "heatmap":            { key: "heatmap",             scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT, requiredPlan: "Pro" },
  "behavioral-biases":  { key: "behavioral-biases",   scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 3, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT, requiredPlan: "Pro" },
  "session-time-slots": { key: "session-time-slots",  scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT, requiredPlan: "Pro" },
  "session-mood":       { key: "session-mood",        scope: "both", minColSpan: 1, maxColSpan: 3, defaultColSpan: 3, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT, requiredPlan: "Pro" },
  "session-duration":   { key: "session-duration",    scope: "both", minColSpan: 1, maxColSpan: 3, defaultColSpan: 3, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT, requiredPlan: "Pro" },
  "session-pnl-chart":  { key: "session-pnl-chart",   scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 4, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 4, rowHeight: GRID_ROW_HEIGHT, requiredPlan: "Pro" },
  "outside-session":  { key: "outside-session",  scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 4, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 2, rowHeight: 140, requiredPlan: "Pro" },
  "session-insight":  { key: "session-insight",  scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 4, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 2, rowHeight: 120, requiredPlan: "Pro" },
  "sessions-list":    { key: "sessions-list",    scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 4, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 6, rowHeight: GRID_ROW_HEIGHT },
  "last-session":     { key: "last-session",     scope: "both", minColSpan: 3, maxColSpan: 6, defaultColSpan: 3, minRowSpan: 4, defaultRowSpan: 5, maxRowSpan: 7, rowHeight: GRID_ROW_HEIGHT },
  "pip-stats":          { key: "pip-stats",           scope: "both", minColSpan: 2, maxColSpan: 4, defaultColSpan: 2, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT },
  "pip-distribution":   { key: "pip-distribution",    scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT },
  "pip-by-symbol":      { key: "pip-by-symbol",       scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT },
  "long-short":         { key: "long-short",          scope: "both", minColSpan: 1, maxColSpan: 6, defaultColSpan: 3, minRowSpan: 1, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT },
  "day-of-week":        { key: "day-of-week",         scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 3, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT },
  "pnl-per-trade":      { key: "pnl-per-trade",       scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT },
  "net-daily-pnl":      { key: "net-daily-pnl",       scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT },
  "risk-adjusted":      { key: "risk-adjusted",       scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 3, minRowSpan: 1, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT, requiredPlan: "Pro" },
  "drawdown-curve":     { key: "drawdown-curve",      scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 4, rowHeight: GRID_ROW_HEIGHT, requiredPlan: "Pro" },
  "hold-duration":      { key: "hold-duration",       scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT, requiredPlan: "Pro" },
  "consistency-score":  { key: "consistency-score",   scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 3, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT, requiredPlan: "Pro" },
  "streak-analysis":    { key: "streak-analysis",     scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 3, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT, requiredPlan: "Pro" },
  "tag-stats":          { key: "tag-stats",           scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 4, rowHeight: GRID_ROW_HEIGHT, requiredPlan: "Pro" },
  "sizing-analysis":    { key: "sizing-analysis",     scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT, requiredPlan: "Pro" },
  "propfirm-kpis":         { key: "propfirm-kpis",         scope: "pfm", minColSpan: 4, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 3, rowHeight: 100 },
  "propfirm-calendar":     { key: "propfirm-calendar",     scope: "pfm", minColSpan: 3, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 4, defaultRowSpan: 4, maxRowSpan: 6, rowHeight: GRID_ROW_HEIGHT },
  "propfirm-month-recap":  { key: "propfirm-month-recap",  scope: "pfm", minColSpan: 2, maxColSpan: 6, defaultColSpan: 3, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: GRID_ROW_HEIGHT },
  "propfirm-reporting":    { key: "propfirm-reporting",    scope: "pfm", minColSpan: 2, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 4, rowHeight: 130 },
  "propfirm-accounts":     { key: "propfirm-accounts",     scope: "pfm", minColSpan: 2, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 2, defaultRowSpan: 3, maxRowSpan: 4, rowHeight: GRID_ROW_HEIGHT },
  "propfirm-payouts-list": { key: "propfirm-payouts-list", scope: "pfm", minColSpan: 2, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 1, defaultRowSpan: 2, maxRowSpan: 4, rowHeight: GRID_ROW_HEIGHT },
  "propfirm-filters":      { key: "propfirm-filters",      scope: "pfm", minColSpan: 6, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 1, rowHeight: PFM_FILTERS_ROW_HEIGHT },
  "propfirm-accounts-table":   { key: "propfirm-accounts-table",   scope: "pfm", minColSpan: 2, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 6, rowHeight: GRID_ROW_HEIGHT },
  "propfirm-global-charges":   { key: "propfirm-global-charges",   scope: "pfm", minColSpan: 2, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 1, defaultRowSpan: 2, maxRowSpan: 4, rowHeight: GRID_ROW_HEIGHT },
  "propfirm-upcoming-charges": { key: "propfirm-upcoming-charges", scope: "pfm", minColSpan: 2, maxColSpan: 6, defaultColSpan: 2, minRowSpan: 2, defaultRowSpan: 3, maxRowSpan: 6, rowHeight: GRID_ROW_HEIGHT },
  "propfirm-wallet-balance":      { key: "propfirm-wallet-balance",      scope: "pfm", minColSpan: 1, maxColSpan: 6, defaultColSpan: 2, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 4, rowHeight: GRID_ROW_HEIGHT },
  "propfirm-wallet-transfers":    { key: "propfirm-wallet-transfers",    scope: "pfm", minColSpan: 3, maxColSpan: 6, defaultColSpan: 2, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 6, rowHeight: GRID_ROW_HEIGHT },
  "propfirm-wallet-withdrawals":  { key: "propfirm-wallet-withdrawals",  scope: "pfm", minColSpan: 3, maxColSpan: 6, defaultColSpan: 2, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 6, rowHeight: GRID_ROW_HEIGHT },
  "propfirm-challenge-overview":  { key: "propfirm-challenge-overview",  scope: "pfm", minColSpan: 1, maxColSpan: 3, defaultColSpan: 2, minRowSpan: 1, defaultRowSpan: 2, maxRowSpan: 3, rowHeight: 100 },
  "note":                      { key: "note",                      scope: "both", minColSpan: 1, maxColSpan: 4, defaultColSpan: 2, minRowSpan: 1, defaultRowSpan: 2, maxRowSpan: 4, rowHeight: GRID_ROW_HEIGHT },
  "discipline-routines": { key: "discipline-routines", scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 3, minRowSpan: 3, defaultRowSpan: 4, maxRowSpan: 6, rowHeight: GRID_ROW_HEIGHT },
  "discipline-goals":    { key: "discipline-goals",    scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 3, minRowSpan: 3, defaultRowSpan: 4, maxRowSpan: 6, rowHeight: GRID_ROW_HEIGHT },
  "notebook-browser":    { key: "notebook-browser",    scope: "both", minColSpan: 3, maxColSpan: 6, defaultColSpan: 4, minRowSpan: 3, defaultRowSpan: 4, maxRowSpan: 6, rowHeight: GRID_ROW_HEIGHT },
  "mentor-notes":              { key: "mentor-notes",              scope: "dashboard", minColSpan: 2, maxColSpan: 6, defaultColSpan: 3, minRowSpan: 2, defaultRowSpan: 2, maxRowSpan: 4, rowHeight: GRID_ROW_HEIGHT },
  "topbar-date-filter":     { key: "topbar-date-filter",     scope: "both", minColSpan: 1, maxColSpan: 1, defaultColSpan: 1, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 1, rowHeight: 0 },
  "topbar-account-filter":  { key: "topbar-account-filter",  scope: "both", minColSpan: 1, maxColSpan: 1, defaultColSpan: 1, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 1, rowHeight: 0 },
  "topbar-strategy-filter": { key: "topbar-strategy-filter", scope: "both", minColSpan: 1, maxColSpan: 1, defaultColSpan: 1, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 1, rowHeight: 0 },
  "topbar-add-trade":       { key: "topbar-add-trade",       scope: "both", minColSpan: 1, maxColSpan: 1, defaultColSpan: 1, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 1, rowHeight: 0 },
  "topbar-add-payout":      { key: "topbar-add-payout",      scope: "both", minColSpan: 1, maxColSpan: 1, defaultColSpan: 1, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 1, rowHeight: 0 },
  "topbar-pfm-filter":      { key: "topbar-pfm-filter",      scope: "both", minColSpan: 1, maxColSpan: 1, defaultColSpan: 1, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 1, rowHeight: 0 },
  "topbar-phase-filter":    { key: "topbar-phase-filter",    scope: "both", minColSpan: 1, maxColSpan: 1, defaultColSpan: 1, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 1, rowHeight: 0 },
  "news-feed":         { key: "news-feed",         scope: "both", minColSpan: 1, maxColSpan: 3, defaultColSpan: 2, minRowSpan: 2, defaultRowSpan: 3, maxRowSpan: 6, rowHeight: 80, requiredPlan: "Pro" },
  "interest-rates":    { key: "interest-rates",    scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 4, rowHeight: 100, requiredPlan: "Pro" },
  "economic-calendar": { key: "economic-calendar", scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 3, minRowSpan: 2, defaultRowSpan: 3, maxRowSpan: 6, rowHeight: 60, requiredPlan: "Pro" },
  "earnings-calendar": { key: "earnings-calendar", scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 3, minRowSpan: 2, defaultRowSpan: 3, maxRowSpan: 6, rowHeight: 60, requiredPlan: "Pro" },
  "chart": { key: "chart", scope: "both", minColSpan: 2, maxColSpan: 6, defaultColSpan: 4, minRowSpan: 2, defaultRowSpan: 3, maxRowSpan: 6, rowHeight: GRID_ROW_HEIGHT, requiredPlan: "Pro" },
  "trades-table":         { key: "trades-table",         scope: "journal", minColSpan: 3, maxColSpan: 6, defaultColSpan: 6, minRowSpan: 3, defaultRowSpan: 4, maxRowSpan: 8, rowHeight: GRID_ROW_HEIGHT },
  "topbar-symbol-filter": { key: "topbar-symbol-filter", scope: "both",    minColSpan: 1, maxColSpan: 1, defaultColSpan: 1, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 1, rowHeight: 0 },
  "topbar-side-filter":   { key: "topbar-side-filter",   scope: "both",    minColSpan: 1, maxColSpan: 1, defaultColSpan: 1, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 1, rowHeight: 0 },
  "topbar-status-filter": { key: "topbar-status-filter", scope: "both",    minColSpan: 1, maxColSpan: 1, defaultColSpan: 1, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 1, rowHeight: 0 },
  "topbar-pnl-filter":    { key: "topbar-pnl-filter",    scope: "both",    minColSpan: 1, maxColSpan: 1, defaultColSpan: 1, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 1, rowHeight: 0 },
  "topbar-tags-filter":   { key: "topbar-tags-filter",   scope: "both",    minColSpan: 1, maxColSpan: 1, defaultColSpan: 1, minRowSpan: 1, defaultRowSpan: 1, maxRowSpan: 1, rowHeight: 0 },
};

export const WIDGET_KEYS = Object.keys(WIDGET_REGISTRY) as WidgetKey[];

export function isKnownWidgetKey(key: string): key is WidgetKey {
  return key in WIDGET_REGISTRY;
}

export function clampColSpan(widgetKey: WidgetKey, requested: number, available: number): number {
  const r = WIDGET_REGISTRY[widgetKey];
  return Math.min(Math.max(r.minColSpan, Math.min(r.maxColSpan, requested)), available);
}

export function clampRowSpan(widgetKey: WidgetKey, requested: number): number {
  const r = WIDGET_REGISTRY[widgetKey];
  return Math.max(r.minRowSpan, Math.min(r.maxRowSpan, requested));
}

let _counter = 0;
function sid(): string { return `default-slot-${++_counter}`; }

/**
 * Version of each scope's default layout. Bump when getDefault<Scope>Layout()
 * changes so existing read-only default layouts get regenerated on next
 * ensure<Scope>DefaultLayout() call (read-only defaults are never user-edited,
 * so regenerating them destroys no user work).
 */
export const DEFAULT_LAYOUT_VERSIONS: Record<LayoutScope, number> = {
  dashboard: 1,
  pfm: 2, // 2: removed stranded profit-factor (row 16 gap), added wallet-withdrawals, contiguous wallet rows
  journal: 1,
  analytics: 4, // 2: added net-pnl/profit-factor/drawdown-curve/session-*; 3: drawdown half-width + monthly-pnl; 4: pip rows rebalanced (risk-adjusted+pip-stats, pip-distribution+pip-by-symbol)
  "custom-page": 1,
  sessions: 3, // 2: sessions-list moved left, last-session right; 3: taller last-session (chart)
  discipline: 1,
};

/** Returns the default layout snapshot for a given scope. */
export function getDefaultLayoutForScope(scope: LayoutScope): LayoutSnapshot {
  switch (scope) {
    case "pfm": return getDefaultPfmLayout();
    case "journal": return getDefaultJournalLayout();
    case "analytics": return getDefaultAnalyticsLayout();
    case "sessions": return getDefaultSessionsLayout();
    case "discipline": return getDefaultDisciplineLayout();
    default: return getDefaultLayout();
  }
}

/**
 * Garantit qu'un utilisateur sans layout custom configuré voit toujours le
 * layout par défaut de la page. Si le snapshot serveur (layout actif) ne
 * contient aucun widget de grille — cas d'un layout actif vide/orphelin créé
 * par une ancienne version du code, ou d'un "Nouveau layout" jamais rempli —
 * on retombe sur le default du scope au rendu plutôt que d'afficher une grille
 * vide. Les slots topbar seuls ne comptent pas comme un layout configuré.
 */
export function withDefaultLayoutFallback(
  snapshot: LayoutSnapshot,
  scope: LayoutScope,
): LayoutSnapshot {
  const hasGridWidget = snapshot.slots.some((s) => s.placement !== "topbar");
  return hasGridWidget ? snapshot : getDefaultLayoutForScope(scope);
}

export function getDefaultLayout(): LayoutSnapshot {
  _counter = 0;
  return {
    slots: [
      // Topbar
      { id: sid(), widgetKey: "topbar-add-trade",        colStart: 1, rowStart: 1, colSpan: 1, rowSpan: 1, placement: "topbar" },
      { id: sid(), widgetKey: "topbar-date-filter",      colStart: 2, rowStart: 1, colSpan: 1, rowSpan: 1, placement: "topbar" },
      { id: sid(), widgetKey: "topbar-account-filter",   colStart: 3, rowStart: 1, colSpan: 1, rowSpan: 1, placement: "topbar" },
      { id: sid(), widgetKey: "topbar-strategy-filter",  colStart: 4, rowStart: 1, colSpan: 1, rowSpan: 1, placement: "topbar" },
      // Row 1 — KPIs
      { id: sid(), widgetKey: "net-pnl",        colStart: 1, rowStart: 1, colSpan: 1, rowSpan: 1 },
      { id: sid(), widgetKey: "profit-factor",  colStart: 2, rowStart: 1, colSpan: 1, rowSpan: 1 },
      { id: sid(), widgetKey: "avg-win-loss",   colStart: 3, rowStart: 1, colSpan: 2, rowSpan: 1 },
      { id: sid(), widgetKey: "win-rate",       colStart: 5, rowStart: 1, colSpan: 2, rowSpan: 1 },
      // Row 2 — Calendar + Equity chart
      { id: sid(), widgetKey: "calendar",       colStart: 1, rowStart: 2, colSpan: 4, rowSpan: 4 },
      { id: sid(), widgetKey: "equity-chart",   colStart: 5, rowStart: 2, colSpan: 2, rowSpan: 2 },
      // Row 4 — Routines + Goals
      { id: sid(), widgetKey: "routines",       colStart: 5, rowStart: 4, colSpan: 1, rowSpan: 1 },
      { id: sid(), widgetKey: "goals",          colStart: 6, rowStart: 4, colSpan: 1, rowSpan: 1 },
      // Row 5 — Market hours
      { id: sid(), widgetKey: "market-hours",   colStart: 5, rowStart: 5, colSpan: 2, rowSpan: 2 },
      // Row 6 — Accounts table
      { id: sid(), widgetKey: "accounts-table", colStart: 1, rowStart: 6, colSpan: 4, rowSpan: 2 },
      // Row 7 — Sessions list
      { id: sid(), widgetKey: "sessions-list",  colStart: 5, rowStart: 7, colSpan: 2, rowSpan: 3 },
      // Row 8 — Analytics
      { id: sid(), widgetKey: "monthly-pnl",     colStart: 1, rowStart: 8, colSpan: 2, rowSpan: 2 },
      { id: sid(), widgetKey: "pnl-distribution", colStart: 3, rowStart: 8, colSpan: 2, rowSpan: 2 },
    ],
  };
}

export function getDefaultPfmLayout(): LayoutSnapshot {
  _counter = 0;
  return {
    slots: [
      // Topbar
      { id: sid(), widgetKey: "topbar-date-filter",     colStart: 1, rowStart: 1, colSpan: 1, rowSpan: 1, placement: "topbar" },
      // Row 1 — KPIs
      { id: sid(), widgetKey: "propfirm-kpis",          colStart: 1, rowStart: 1, colSpan: 6, rowSpan: 1 },
      // Row 2 — Calendar + Month recap
      { id: sid(), widgetKey: "propfirm-calendar",      colStart: 1, rowStart: 2, colSpan: 4, rowSpan: 4 },
      { id: sid(), widgetKey: "propfirm-month-recap",   colStart: 5, rowStart: 2, colSpan: 2, rowSpan: 2 },
      // Row 4 — Payouts list
      { id: sid(), widgetKey: "propfirm-payouts-list",  colStart: 5, rowStart: 4, colSpan: 2, rowSpan: 2 },
      // Row 6 — Reporting
      { id: sid(), widgetKey: "propfirm-reporting",     colStart: 1, rowStart: 6, colSpan: 6, rowSpan: 2 },
      // Row 8 — Accounts + Wallet balance
      { id: sid(), widgetKey: "propfirm-accounts",        colStart: 1, rowStart: 8, colSpan: 3, rowSpan: 2 },
      { id: sid(), widgetKey: "propfirm-wallet-balance",  colStart: 4, rowStart: 8, colSpan: 3, rowSpan: 2 },
      // Row 10 — Wallet transfers + Wallet withdrawals
      { id: sid(), widgetKey: "propfirm-wallet-transfers",   colStart: 1, rowStart: 10, colSpan: 3, rowSpan: 2 },
      { id: sid(), widgetKey: "propfirm-wallet-withdrawals", colStart: 4, rowStart: 10, colSpan: 3, rowSpan: 2 },
      // Row 12 — Global charges
      { id: sid(), widgetKey: "propfirm-global-charges",    colStart: 1, rowStart: 12, colSpan: 6, rowSpan: 2 },
      // Row 14 — Upcoming charges (à confirmer, 30 prochains jours)
      { id: sid(), widgetKey: "propfirm-upcoming-charges",  colStart: 1, rowStart: 14, colSpan: 6, rowSpan: 3 },
    ],
  };
}

export function getDefaultJournalLayout(): LayoutSnapshot {
  _counter = 0;
  return {
    slots: [
      // Topbar
      { id: sid(), widgetKey: "topbar-add-trade",       colStart: 1, rowStart: 1, colSpan: 1, rowSpan: 1, placement: "topbar" },
      { id: sid(), widgetKey: "topbar-date-filter",     colStart: 2, rowStart: 1, colSpan: 1, rowSpan: 1, placement: "topbar" },
      { id: sid(), widgetKey: "topbar-account-filter",  colStart: 3, rowStart: 1, colSpan: 1, rowSpan: 1, placement: "topbar" },
      { id: sid(), widgetKey: "topbar-strategy-filter", colStart: 4, rowStart: 1, colSpan: 1, rowSpan: 1, placement: "topbar" },
      // Row 1 — KPIs
      { id: sid(), widgetKey: "net-pnl",       colStart: 1, rowStart: 1, colSpan: 1, rowSpan: 1 },
      { id: sid(), widgetKey: "profit-factor", colStart: 2, rowStart: 1, colSpan: 1, rowSpan: 1 },
      { id: sid(), widgetKey: "win-rate",      colStart: 3, rowStart: 1, colSpan: 2, rowSpan: 1 },
      { id: sid(), widgetKey: "avg-win-loss",  colStart: 5, rowStart: 1, colSpan: 2, rowSpan: 1 },
      // Row 2 — Trades table
      { id: sid(), widgetKey: "trades-table",  colStart: 1, rowStart: 2, colSpan: 6, rowSpan: 4 },
    ],
  };
}

export function getDefaultAnalyticsLayout(): LayoutSnapshot {
  _counter = 0;
  return {
    slots: [
      // Topbar
      { id: sid(), widgetKey: "topbar-date-filter",     colStart: 1, rowStart: 1, colSpan: 1, rowSpan: 1, placement: "topbar" },
      { id: sid(), widgetKey: "topbar-account-filter",  colStart: 2, rowStart: 1, colSpan: 1, rowSpan: 1, placement: "topbar" },
      { id: sid(), widgetKey: "topbar-strategy-filter", colStart: 3, rowStart: 1, colSpan: 1, rowSpan: 1, placement: "topbar" },
      // Row 1 — KPIs (PnL Total, Profit Factor, Win Rate, Avg Win/Loss)
      { id: sid(), widgetKey: "net-pnl",       colStart: 1, rowStart: 1, colSpan: 1, rowSpan: 1 },
      { id: sid(), widgetKey: "profit-factor", colStart: 2, rowStart: 1, colSpan: 1, rowSpan: 1 },
      { id: sid(), widgetKey: "win-rate",      colStart: 3, rowStart: 1, colSpan: 2, rowSpan: 1 },
      { id: sid(), widgetKey: "avg-win-loss",  colStart: 5, rowStart: 1, colSpan: 2, rowSpan: 1 },
      // Row 2 — Advanced KPIs + Equity
      { id: sid(), widgetKey: "analytics-kpis", colStart: 1, rowStart: 2, colSpan: 2, rowSpan: 2 },
      { id: sid(), widgetKey: "equity-curve",   colStart: 3, rowStart: 2, colSpan: 4, rowSpan: 2 },
      // Row 4 — Distribution + Symbol
      { id: sid(), widgetKey: "pnl-distribution",   colStart: 1, rowStart: 4, colSpan: 3, rowSpan: 2 },
      { id: sid(), widgetKey: "symbol-performance", colStart: 4, rowStart: 4, colSpan: 3, rowSpan: 2 },
      // Row 6 — Long/Short + Day of Week + Rolling WR
      { id: sid(), widgetKey: "long-short",       colStart: 1, rowStart: 6, colSpan: 2, rowSpan: 2 },
      { id: sid(), widgetKey: "day-of-week",      colStart: 3, rowStart: 6, colSpan: 2, rowSpan: 2 },
      { id: sid(), widgetKey: "rolling-win-rate", colStart: 5, rowStart: 6, colSpan: 2, rowSpan: 2 },
      // Row 8 — Heatmap + Hold duration
      { id: sid(), widgetKey: "heatmap",       colStart: 1, rowStart: 8, colSpan: 4, rowSpan: 2 },
      { id: sid(), widgetKey: "hold-duration", colStart: 5, rowStart: 8, colSpan: 2, rowSpan: 2 },
      // Row 10 — PnL per trade + Net daily PnL
      { id: sid(), widgetKey: "pnl-per-trade", colStart: 1, rowStart: 10, colSpan: 3, rowSpan: 2 },
      { id: sid(), widgetKey: "net-daily-pnl", colStart: 4, rowStart: 10, colSpan: 3, rowSpan: 2 },
      // Row 12 — Drawdown curve (half width) + Monthly PnL
      { id: sid(), widgetKey: "drawdown-curve", colStart: 1, rowStart: 12, colSpan: 3, rowSpan: 2 },
      { id: sid(), widgetKey: "monthly-pnl",    colStart: 4, rowStart: 12, colSpan: 3, rowSpan: 2 },
      // Row 14 — Consistency + Streak + Behavioral
      { id: sid(), widgetKey: "consistency-score", colStart: 1, rowStart: 14, colSpan: 2, rowSpan: 2 },
      { id: sid(), widgetKey: "streak-analysis",   colStart: 3, rowStart: 14, colSpan: 2, rowSpan: 2 },
      { id: sid(), widgetKey: "behavioral-biases", colStart: 5, rowStart: 14, colSpan: 2, rowSpan: 2 },
      // Row 16 — Tag stats + Sizing
      { id: sid(), widgetKey: "tag-stats",       colStart: 1, rowStart: 16, colSpan: 3, rowSpan: 2 },
      { id: sid(), widgetKey: "sizing-analysis", colStart: 4, rowStart: 16, colSpan: 3, rowSpan: 2 },
      // Row 18 — Risk adjusted + Pip stats
      { id: sid(), widgetKey: "risk-adjusted", colStart: 1, rowStart: 18, colSpan: 3, rowSpan: 2 },
      { id: sid(), widgetKey: "pip-stats",     colStart: 4, rowStart: 18, colSpan: 3, rowSpan: 2 },
      // Row 20 — Pip distribution + Pip by symbol
      { id: sid(), widgetKey: "pip-distribution", colStart: 1, rowStart: 20, colSpan: 3, rowSpan: 2 },
      { id: sid(), widgetKey: "pip-by-symbol",    colStart: 4, rowStart: 20, colSpan: 3, rowSpan: 2 },
      // Row 22 — Sessions: time slots + mood
      { id: sid(), widgetKey: "session-time-slots", colStart: 1, rowStart: 22, colSpan: 3, rowSpan: 2 },
      { id: sid(), widgetKey: "session-mood",       colStart: 4, rowStart: 22, colSpan: 3, rowSpan: 2 },
      // Row 24 — Sessions: duration + key insight
      { id: sid(), widgetKey: "session-duration", colStart: 1, rowStart: 24, colSpan: 3, rowSpan: 2 },
      { id: sid(), widgetKey: "session-insight",  colStart: 4, rowStart: 24, colSpan: 3, rowSpan: 1 },
    ],
  };
}

export function getDefaultSessionsLayout(): LayoutSnapshot {
  _counter = 0;
  return {
    slots: [
      // Topbar — date filter only (Add Session is a page-level action button)
      { id: sid(), widgetKey: "topbar-date-filter", colStart: 1, rowStart: 1, colSpan: 1, rowSpan: 1, placement: "topbar" },
      // Row 1 — Sessions list (left) + Last session w/ chart (right, taller)
      { id: sid(), widgetKey: "sessions-list", colStart: 1, rowStart: 1, colSpan: 3, rowSpan: 3 },
      { id: sid(), widgetKey: "last-session",  colStart: 4, rowStart: 1, colSpan: 3, rowSpan: 5 },
      // Row 4 — Mood + Duration (left column, beside the tall chart)
      { id: sid(), widgetKey: "session-mood",     colStart: 1, rowStart: 4, colSpan: 3, rowSpan: 2 },
      // Row 6 — Duration + Time slots
      { id: sid(), widgetKey: "session-duration",   colStart: 4, rowStart: 6, colSpan: 3, rowSpan: 2 },
      { id: sid(), widgetKey: "session-time-slots", colStart: 1, rowStart: 6, colSpan: 3, rowSpan: 2 },
    ],
  };
}

export function getDefaultDisciplineLayout(): LayoutSnapshot {
  _counter = 0;
  return {
    slots: [
      // Topbar — date filter only
      { id: sid(), widgetKey: "topbar-date-filter", colStart: 1, rowStart: 1, colSpan: 1, rowSpan: 1, placement: "topbar" },
      // Row 1 — Routines + Goals (3×4 side by side)
      { id: sid(), widgetKey: "discipline-routines", colStart: 1, rowStart: 1, colSpan: 3, rowSpan: 4 },
      { id: sid(), widgetKey: "discipline-goals",    colStart: 4, rowStart: 1, colSpan: 3, rowSpan: 4 },
      // Row 5 — Notebook browser (full width)
      { id: sid(), widgetKey: "notebook-browser",    colStart: 1, rowStart: 5, colSpan: 6, rowSpan: 4 },
    ],
  };
}

export type WidgetCategoryKey =
  | "dashboard"
  | "journal"
  | "analytics"
  | "analyticsPerformance"
  | "analyticsSessions"
  | "analyticsPips"
  | "propFirm"
  | "notes"
  | "mentorProgram"
  | "topbar"
  | "marketData"
  | "sessions"
  | "discipline";

export interface WidgetCategory {
  key: WidgetCategoryKey;
  scope: LayoutScope | "both";
  widgets: WidgetKey[];
}

export const WIDGET_CATEGORIES: WidgetCategory[] = [
  { key: "dashboard",           scope: "dashboard", widgets: ["net-pnl","profit-factor","win-rate","avg-win-loss","calendar","market-hours","routines","goals","session","equity-chart","accounts-table"] },
  { key: "journal", scope: "journal" as const, widgets: ["trades-table", "net-pnl", "profit-factor", "win-rate", "avg-win-loss"] as WidgetKey[] },
  { key: "analytics", scope: "analytics" as const, widgets: ["analytics-kpis","equity-curve","pnl-distribution","symbol-performance","long-short","day-of-week","rolling-win-rate","heatmap","hold-duration","pnl-per-trade","net-daily-pnl","consistency-score","streak-analysis","behavioral-biases","monthly-pnl","tag-stats","sizing-analysis","risk-adjusted","drawdown-curve","pip-stats","pip-distribution","pip-by-symbol","session-time-slots","session-mood","session-duration","session-pnl-chart","outside-session","session-insight","sessions-list"] as WidgetKey[] },
  { key: "analyticsPerformance",scope: "dashboard", widgets: ["analytics-kpis","equity-curve","pnl-distribution","monthly-pnl","symbol-performance","rolling-win-rate","heatmap","behavioral-biases","long-short","day-of-week","pnl-per-trade","net-daily-pnl","risk-adjusted","drawdown-curve","consistency-score","streak-analysis","tag-stats","sizing-analysis"] },
  { key: "analyticsSessions",   scope: "dashboard", widgets: ["last-session","session-time-slots","session-mood","session-duration","session-pnl-chart","outside-session","session-insight","sessions-list","hold-duration"] },
  { key: "sessions",            scope: "sessions" as const, widgets: ["last-session","sessions-list","session-mood","session-duration","session-pnl-chart","session-time-slots","outside-session","session-insight","note"] as WidgetKey[] },
  { key: "analyticsPips",       scope: "dashboard", widgets: ["pip-stats","pip-distribution","pip-by-symbol"] },
  { key: "propFirm",            scope: "pfm",       widgets: ["propfirm-filters","propfirm-kpis","propfirm-challenge-overview","propfirm-calendar","propfirm-month-recap","propfirm-reporting","propfirm-accounts-table","propfirm-global-charges","propfirm-upcoming-charges","propfirm-accounts","propfirm-payouts-list","propfirm-wallet-balance","propfirm-wallet-transfers","propfirm-wallet-withdrawals"] },
  { key: "notes",               scope: "both" as const, widgets: ["note"] as WidgetKey[] },
  { key: "discipline",          scope: "discipline" as const, widgets: ["discipline-routines","discipline-goals","notebook-browser","note"] as WidgetKey[] },
  { key: "mentorProgram",       scope: "dashboard", widgets: ["mentor-notes"] as WidgetKey[] },
  { key: "topbar", scope: "both" as const, widgets: ["topbar-date-filter", "topbar-account-filter", "topbar-strategy-filter", "topbar-add-trade", "topbar-add-payout", "topbar-pfm-filter", "topbar-phase-filter", "topbar-symbol-filter", "topbar-side-filter", "topbar-status-filter", "topbar-pnl-filter", "topbar-tags-filter"] as WidgetKey[] },
  { key: "marketData", scope: "both" as const, widgets: ["news-feed", "interest-rates", "economic-calendar", "earnings-calendar", "chart"] as WidgetKey[] },
];

/**
 * Les métriques analytics calculables, telles qu'exposées par `analyticsData`.
 * Une métrique = une passe de calcul sur l'historique complet des trades.
 */
export type AnalyticsMetric =
  | "symbolStats"
  | "monthlyStats"
  | "cumulativePnl"
  | "pnlDistribution"
  | "rollingWinRate"
  | "heatmapData"
  | "timeSlotStats"
  | "holdDurationData"
  | "tagStats"
  | "behavioralBiases"
  | "sessionStats"
  | "pipStats"
  | "pipBuckets"
  | "pipBySymbol"
  | "calmarRatio"
  | "recoveryFactor"
  | "sizingData"
  | "longShort"
  | "dayOfWeek"
  | "streakData"
  | "consistencyScore"
  | "netDailyPnl"
  | "drawdownCurve";

/**
 * Quelles métriques chaque widget consomme réellement.
 *
 * SOURCE DE VÉRITÉ du calcul à la carte : `useAnalyticsData` ne calcule que les
 * métriques réclamées par les widgets réellement présents dans le layout. Avant,
 * afficher un seul widget déclenchait les 23 passes de calcul sur tout
 * l'historique (INP p75 > 200 ms sur toutes les pages à widgets).
 *
 * ⚠️ En ajoutant un widget analytics, l'inscrire ICI. Un widget absent de cette
 * map ne recevra aucune métrique et affichera son état vide. Le test
 * `analyticsMetrics.test.ts` vérifie que chaque champ lu par un widget est bien
 * déclaré, et que les clés couvrent ANALYTICS_WIDGET_KEYS.
 */
export const WIDGET_ANALYTICS_METRICS: Partial<Record<WidgetKey, readonly AnalyticsMetric[]>> = {
  "analytics-kpis":     ["calmarRatio", "recoveryFactor"],
  "equity-curve":       ["cumulativePnl"],
  "pnl-distribution":   ["pnlDistribution"],
  "monthly-pnl":        ["monthlyStats"],
  "symbol-performance": ["symbolStats"],
  "rolling-win-rate":   ["rollingWinRate"],
  "heatmap":            ["heatmapData"],
  "behavioral-biases":  ["behavioralBiases"],
  "session-time-slots": ["timeSlotStats", "sessionStats"],
  "session-mood":       ["sessionStats"],
  "session-duration":   ["sessionStats"],
  "session-pnl-chart":  ["sessionStats"],
  "outside-session":    ["sessionStats"],
  "session-insight":    ["sessionStats"],
  "pip-stats":          ["pipStats"],
  "pip-distribution":   ["pipBuckets"],
  "pip-by-symbol":      ["pipBySymbol"],
  "long-short":         ["longShort"],
  "day-of-week":        ["dayOfWeek"],
  "pnl-per-trade":      ["sizingData"],
  "net-daily-pnl":      ["netDailyPnl"],
  "risk-adjusted":      ["calmarRatio", "recoveryFactor"],
  "drawdown-curve":     ["drawdownCurve"],
  "hold-duration":      ["holdDurationData"],
  // consistencyScore dérive de streakData — la dépendance est résolue dans
  // useAnalyticsData, mais on la déclare pour rester explicite.
  "consistency-score":  ["consistencyScore", "streakData"],
  "streak-analysis":    ["streakData"],
  "tag-stats":          ["tagStats"],
  "sizing-analysis":    ["sizingData"],
};

/**
 * Widgets dont l'affichage nécessite au moins une métrique analytics.
 * Dérivé de WIDGET_ANALYTICS_METRICS pour que les deux ne puissent pas diverger.
 */
export const ANALYTICS_WIDGET_KEYS: WidgetKey[] = Object.keys(
  WIDGET_ANALYTICS_METRICS,
) as WidgetKey[];

/**
 * L'ensemble des métriques à calculer pour un layout donné — l'union des besoins
 * de chaque widget présent. Retourne un Set vide si aucun widget n'en réclame,
 * auquel cas aucun calcul n'est effectué.
 */
export function metricsForWidgetKeys(
  widgetKeys: readonly WidgetKey[],
): Set<AnalyticsMetric> {
  const metrics = new Set<AnalyticsMetric>();
  for (const key of widgetKeys) {
    const needed = WIDGET_ANALYTICS_METRICS[key];
    if (!needed) continue;
    for (const metric of needed) metrics.add(metric);
  }
  return metrics;
}

export const PROPFIRM_WIDGET_KEYS: WidgetKey[] = [
  "propfirm-kpis","propfirm-calendar","propfirm-month-recap","propfirm-reporting","propfirm-accounts","propfirm-payouts-list",
];

export const PROPFIRM_ONLY_WIDGET_KEYS: WidgetKey[] = [
  "propfirm-filters","propfirm-kpis","propfirm-challenge-overview","propfirm-calendar","propfirm-month-recap","propfirm-reporting","propfirm-accounts-table","propfirm-global-charges","propfirm-upcoming-charges","propfirm-accounts","propfirm-payouts-list","propfirm-wallet-balance","propfirm-wallet-transfers","propfirm-wallet-withdrawals",
];

export function isWidgetLocked(widgetKey: WidgetKey, isFreePlan: boolean): boolean {
  const entry = WIDGET_REGISTRY[widgetKey];
  return isFreePlan && !!entry?.requiredPlan;
}

/**
 * Widgets qui restent des métriques compactes sur mobile alors que leur
 * `defaultColSpan` est > 1 sur la grille desktop. Sans cette liste, `win-rate`
 * (colSpan 2) sortirait du bloc 2×2 des KPI et s'afficherait en pleine largeur,
 * ce qui casserait l'alignement visuel des 4 métriques du haut.
 */
const MOBILE_KPI_OVERRIDES = new Set<WidgetKey>(["win-rate"]);

/**
 * Un KPI mobile = une métrique étroite, affichée à 2 par ligne. Tout le reste
 * (calendriers, listes, charts, tableaux) passe en pleine largeur : sur ~370px
 * il n'y a pas la place d'afficher quoi que ce soit à côté.
 *
 * NB : on ne teste PAS `rowHeight` — la convention Pro Terminal impose 150px
 * aux KPI comme à beaucoup d'autres widgets, ce n'est donc pas discriminant.
 * Les widgets topbar (`rowHeight: 0`) ne sont jamais rendus dans la grille.
 */
export function isMobileKpiWidget(widgetKey: WidgetKey): boolean {
  const entry = WIDGET_REGISTRY[widgetKey];
  if (!entry || entry.rowHeight === 0) return false;
  return MOBILE_KPI_OVERRIDES.has(widgetKey) || entry.defaultColSpan <= 1;
}

/**
 * Hauteur d'un widget en pleine largeur sur mobile, en pixels.
 *
 * Sur mobile les slots sont empilés dans un simple flex : ni `rowSpan` ni la
 * grille CSS ne s'appliquent, donc sans hauteur explicite le conteneur prend la
 * taille de son contenu. Un widget à liste (news, calendrier économique) s'étire
 * alors sur des centaines de pixels et son `overflow-y-auto` interne ne se
 * déclenche jamais — c'est ce qui rendait le flux d'actualités interminable.
 *
 * On borne donc la hauteur à partir du registry, en conservant la proportion
 * voulue par le widget (`defaultRowSpan × rowHeight`) mais dans une fourchette
 * lisible sur un écran ~370px de large.
 */
export const MOBILE_MIN_WIDGET_HEIGHT = 220;
export const MOBILE_MAX_WIDGET_HEIGHT = 420;

export function getMobileWidgetHeight(widgetKey: WidgetKey): number | undefined {
  const entry = WIDGET_REGISTRY[widgetKey];
  // rowHeight 0 = widget topbar, jamais rendu dans la grille.
  if (!entry || entry.rowHeight === 0) return undefined;
  const natural = entry.defaultRowSpan * entry.rowHeight;
  return Math.min(Math.max(natural, MOBILE_MIN_WIDGET_HEIGHT), MOBILE_MAX_WIDGET_HEIGHT);
}

/** Sépare les slots en métriques compactes (grille 2 col.) et widgets pleine largeur. */
export function partitionMobileSlots<T extends { widgetKey: WidgetKey }>(
  slots: T[],
): { kpis: T[]; fullWidth: T[] } {
  const kpis: T[] = [];
  const fullWidth: T[] = [];
  for (const slot of slots) {
    (isMobileKpiWidget(slot.widgetKey) ? kpis : fullWidth).push(slot);
  }
  return { kpis, fullWidth };
}

export function computeGlobalEmptySlots(slots: SlotPlacement[]): Array<{ col: number; row: number }> {
  const maxRow = slots.reduce((m, s) => Math.max(m, s.rowStart + s.rowSpan - 1), 0);
  const scanTo = maxRow + 1;

  const occupied = new Set<string>();
  for (const s of slots) {
    for (let c = s.colStart; c < s.colStart + s.colSpan; c++) {
      for (let r = s.rowStart; r < s.rowStart + s.rowSpan; r++) occupied.add(`${c},${r}`);
    }
  }

  const empty: Array<{ col: number; row: number }> = [];
  for (let r = 1; r <= scanTo; r++) {
    for (let c = 1; c <= GRID_COLS; c++) {
      if (!occupied.has(`${c},${r}`)) empty.push({ col: c, row: r });
    }
  }
  return empty;
}
